import React from "react";

export const LazyCreateDealProjectPage = React.lazy(
  () => import("modules/investorRole/pages/DealsPage/CreateDealPage/CreateDealProjectPage/index"),
);
